import React from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";

import "./ContactUsSection.css";
import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt, FaWhatsapp } from "react-icons/fa";

const ContactUsSection = () => {
  return (
    <section className="contact-section py-5">
      <Container>
        <h2 className="text-center mb-5 gradient-text">Get in Touch</h2>
        <Row className="align-items-stretch">
          {/* Contact Form */}
          <Col md={6} className="mb-4 mb-md-0 slide-from-left">
            <div className="form-container p-4 p-md-5 shadow-lg rounded-4">
              <Form>
                <Form.Group className="mb-4" controlId="formName">
                  <Form.Control type="text" placeholder="Your Name" className="input-style" />
                </Form.Group>

                <Form.Group className="mb-4" controlId="formEmail">
                  <Form.Control type="email" placeholder="Your Email" className="input-style" />
                </Form.Group>

                <Form.Group className="mb-4" controlId="formPhone">
                  <Form.Control type="tel" placeholder="Phone Number" className="input-style" />
                </Form.Group>

                <Form.Group className="mb-4" controlId="formMessage">
                  <Form.Control as="textarea" rows={4} placeholder="Your Message" className="input-style" />
                </Form.Group>

                <div className="d-grid">
                  <Button variant="primary" type="submit" className="gradient-btn">
                    Send Message
                  </Button>
                </div>
              </Form>
            </div>
          </Col>

          {/* Contact Info & Map */}
          <Col md={6} className="slide-from-right">
            <div className="info-box bg-white p-4 p-md-5 rounded-4 shadow-sm mb-4">
              <div className="d-flex align-items-center mb-3">
               <FaMapMarkerAlt size={24} style={{ color: 'purple' }} className="me-3" />

                <p className="mb-0">Zarinova, yeshashree apt, Z conner, Pune, Maharashtra 412307, India</p>
              </div>
              <div className="d-flex align-items-center mb-4">
                <FaEnvelope size={24} className="me-3" style={{ color: 'purple' }} />
                <p className="mb-0">rahim@zarinova.in</p>
              </div>
           <div className="d-flex align-items-center mb-4">
  <FaPhoneAlt size={24} className="me-3" style={{ color: 'purple' }} />
  <p className="mb-0">(91)+ 9657385305</p>
</div>

<div className="d-flex align-items-center mb-4">
  <FaWhatsapp size={24} className="me-3" style={{ color: 'green' }} />
  <p className="mb-0">(91)+ 8483829335</p>
</div>


              <div className="map-responsive">
            <iframe
  title="Vevent Location"
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3782.430126842826!2d73.85702191489324!3d18.552437272793756!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c0229ae53ef3%3A0xd4d8390b08b8c2cb!2sZarinova%2C%20Yeshashree%20Apartment%2C%20Z%20Corner%2C%20Pune%2C%20Maharashtra%20412307%2C%20India!5e0!3m2!1sen!2sin!4v1718271111111!5m2!1sen!2sin"
  width="100%"
  height="250"
  style={{ border: 0 }}
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>



              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ContactUsSection;
